/**
 * Replaces every dash on a string with a space and capitalize each word of it.
 *
 * @param {string} str The string to capitalize
 * @return {string} x capitalized string
 */
export const capitalize = (str) => {
    return str.replace(/_/g, ' ')
        .replace(/(?: |\b)(\w)/g, (key) => {
        return key.toUpperCase();
    });
};
/**
 * Creates an actual object from a notation path.
 * e.g - "user.profile.addresses.0.street"
 *
 * @param {object} obj The initial object from where we are going to start creating the new one
 * @param {string | string[]} path notation path
 * @param {any} value value of the leaf
 * @return {object} obj the actual object created
 */
export const createObjFromPath = (obj, path, value, field = 'diff') => {
    var _a;
    path = typeof path === 'string' ? path.split('.') : path;
    let current = obj;
    while (path.length > 1) {
        // @ts-ignore
        let [head, ...tail] = path;
        path = tail;
        const [second, ...rest] = tail;
        let parsedHead = head;
        if (Array.isArray(current)) {
            // Head is an index for arrays, converting it to number
            parsedHead = Number(head);
            if (typeof current[parsedHead] === 'undefined') {
                // Checking overflow, adding empty elements to array if there are less elements than expected
                if (!current.length) {
                    for (let i = 0; i <= parsedHead; i++) {
                        current.push({});
                    }
                }
                else {
                    let flag = true;
                    for (let i = parsedHead; flag; i--) {
                        if (!current[i]) {
                            current.push({});
                        }
                        else {
                            flag = false;
                        }
                    }
                }
            }
        }
        else if (current[parsedHead] === undefined) {
            if (second && isNumeric(second)) {
                current[parsedHead] = [];
            }
            else {
                current[parsedHead] = {};
            }
        }
        current = (_a = current[parsedHead]) !== null && _a !== void 0 ? _a : {};
    }
    current[path[0]] = value;
    obj = formatArrayDifferences(obj, field);
    return obj;
};
const formatArrayDifferences = (v, field, comesFromArray = false) => {
    if (v === null) {
        if (comesFromArray)
            return ' ';
        return;
    }
    if (Array.isArray(v)) {
        v = v.map((el) => {
            return formatArrayDifferences(el, field, true);
        });
        return v;
    }
    if (typeof v === 'string' && comesFromArray) {
        if (!v.startsWith('+ ') && !v.startsWith('- ')) {
            if (field === 'diff') {
                return `+ ${v}`;
            }
            else {
                return `- ${v}`;
            }
        }
    }
    if (typeof v === 'object') {
        Object.keys(v).forEach((key) => {
            v[key] = formatArrayDifferences(v[key], field, false);
        });
        return v;
    }
    return v;
};
/**
 * Checks if a string is number or not.
 *  e.g
 * "100"  - true
 * "2"    - true
 * "-14"  - false
 *
 * @param {string} value The stringified number
 * @return {boolean} x true if is a number, false if not
 */
export const isNumeric = (value) => {
    return /^\d+$/.test(value);
};
//# sourceMappingURL=strings.js.map